import { Carnivore } from '@bluebeam/carnivore';

class CarnivoreCtx {
  ctx: Carnivore;

  constructor(carnCtx: Carnivore) {
    this.ctx = carnCtx;
  }

  destroy(): void {
    this.ctx.destroy();
    this.ctx.free();
  }
}

export default CarnivoreCtx;
